import { useEffect, useRef, useState } from 'react';
import './App.css';

function App() {
  const [todos,setTodos]=useState(() => {
    const saved = localStorage.getItem("todos");
    return saved ? JSON.parse(saved) : [];
  });
  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));
  }, [todos]);

  const inputRef =useRef();

  const handleAddTodo =()=>{
    const text =inputRef.current.value;
    const newItem = {completed:false,text};
    text !== "" && setTodos([...todos,newItem]) 
    inputRef.current.value=""
  }
  const handleItemDone =(index)=>{
    const newTodos =[...todos];
    newTodos[index].completed =!newTodos[index].completed;
    setTodos(newTodos);
  }

  const handleDeleteItem =(index)=>{ 
    const confirmDelete = window.confirm("Delete Task ?");
    if(confirmDelete){
      const newTodos =[...todos];
      newTodos.splice(index,1);
      setTodos(newTodos);
    }
    
  }
  
  return (
    <div className="App">
      
      <div className='container'>
        <h2>To Do List</h2> 
        <div className='input-container'>
          <input ref={inputRef} placeholder='Task..'/>
          <button onClick={()=>{handleAddTodo()}}>Add</button>
        </div>  
        
          <ul>
            {todos.map((todo,index)=>(
              <div className='list-item' key={index}>
                <i className={todo.completed ? "fa-solid fa-circle-check" : "fa-regular fa-circle"}
                  onClick={() => handleItemDone(index)}
                ></i>
                <li className={todo.completed ? "done" : ""}
                  onClick={()=>{handleItemDone(index)}} >
                    {todo.text}
                </li>
                <i class="fa-solid fa-xmark"
                onClick={()=>{handleDeleteItem(index)}}>
                </i>              
              </div>
          ))}
          </ul>
      

      </div>

    </div>
  );
}

export default App;
